import { render, staticRenderFns } from "./IdentifiantsCard.vue?vue&type=template&id=7016b2fe"
import script from "./IdentifiantsCard.vue?vue&type=script&lang=js"
export * from "./IdentifiantsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports